import { getFeeTypeNameById } from '../../Enums/feetypes';
import { ROUTE_AGENCY_SPECIFIC_COST_ESTIMATE } from '../../routes/Routes';
import SpecificCostEstimate from './SpecificCostEstimate';

export default function AgencySpecificCostEstimate() {
    const agencyFeeType = getFeeTypeNameById(3);
    const {title} = ROUTE_AGENCY_SPECIFIC_COST_ESTIMATE;

    return <SpecificCostEstimate feeTypeFilter={agencyFeeType} pageTitle={title} />
}
